import { Userbot } from "../../interfaces"

/** Форматирует LaunchOrigin в человекочитаемый бейдж (SPEC §10.3). */
export const formatOrigin = (
  origin?: Userbot.ReportProvenance["origin"],
): string => {
  if (!origin) return "—"
  switch (origin.kind) {
    case "api":
      return origin.userId ? `API (${origin.userId})` : "API"
    case "trigger":
      return `trigger:${origin.triggerId}`
    case "schedule":
      return `schedule:${origin.scheduleId}`
    case "template":
      return origin.version != null
        ? `template:${origin.templateId}:v${origin.version}`
        : `template:${origin.templateId}`
    case "followUp":
      return `followUp:${origin.parentChainId}`
    case "callChain":
      return `callChain:${origin.parentChainId}`
    default:
      return typeof origin.kind === "string" ? origin.kind : "—"
  }
}

/** Форматирует ошибку шага: предпочитает errorKind (TgErrorKind), fallback на failedReason (SPEC §6). */
export const formatStepFailure = (step: Userbot.ChainReportStep): string => {
  if (step.errorKind) {
    switch (step.errorKind.kind) {
      case "floodWait":
        return `FloodWait, ждать ${step.errorKind.seconds} сек`
      case "sessionDead":
        return "Сессия мертва"
      case "freshResetForbidden":
        return "Telegram запрещает сброс сессий для аккаунта младше 24ч. Перезапустите шаблон не ранее чем через 24ч после импорта."
      case "alreadyParticipant":
        return "Уже участник"
      case "inviteRequestSent":
        return "Заявка отправлена"
      case "rpc":
        return `RPC ${step.errorKind.code}: ${step.errorKind.text}`
      case "network":
        return step.failedReason
          ? `Сетевая ошибка: ${step.failedReason}`
          : "Сетевая ошибка"
      case "unknown":
        return step.failedReason
          ? `Неизвестная ошибка: ${step.failedReason}`
          : "Неизвестная ошибка"
    }
  }
  return step.failedReason ?? "—"
}
